import React from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import LoginPage from "./LoginPage";
import UploadDomain from "./UploadDomain";
import ManageCategory from "./ManageCategory";
import ViewDomains from "./ViewDomains";
import HomePage from "./HomePage";
import DomainSearchResultsPage from "./DomainSearchResultsPage";
import DashBoard from "./DashBoard";
import UserDashBoard from "./UserDashBoard";
import UserDomains from "./UserDomains";
import UserPayments from "./UserPayments";
import UserProfile from "./UserProfile";
import ChiSiamo from "./ChiSiamo";
import FAQ from "./FAQ";
import Supporto from "./Supporto";
import RegisterPage from "./RegisterPage";
import BuyDomainPage from "./BuyDomainPage";
import PaymentStepper from "./PaymentStepper"; 
import PaymentForm from "./PaymentForm";
import UserSidebar from "./UserSidebar";
import PaymentList from "./PaymentList";
import UserList from "./UserList";

// Aggiungi un componente wrapper per gestire la visibilità del footer
const FooterWrapper = () => {
  const location = useLocation();
  
  // Aggiungi qui le pagine dove non vuoi il Footer
  const hideFooterPages = ['/login', '/register'];

  // Verifica se siamo su una delle pagine da nascondere
  if (hideFooterPages.includes(location.pathname)) {
    return null; // Non renderizza il footer
  }

  return <Footer />; // Renderizza il footer su tutte le altre pagine
};

const App = () => {
  return (
    <Router>
      <div className="flex flex-col w-full min-h-screen">
        <Header />
        <main className="flex-grow p-0 text-center">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/upload-domain" element={<UploadDomain />} />
            <Route path="/manage-category" element={<ManageCategory />} />
            <Route path="/view-domains" element={<ViewDomains />} />
            <Route path="/search-results" element={<DomainSearchResultsPage />} />
            <Route path="/buy-domain" element={<BuyDomainPage />} />
            <Route path="/admin-dashboard" element={<DashBoard />} />
            <Route path="/admin-payments" element={<PaymentList />} />
            <Route path="/admin-userlist" element={<UserList />} />
            <Route path="/user-dashboard" element={<UserDashBoard />} />
            <Route path="/user-domains" element={<UserDomains />} />
            <Route path="/user-orders" element={<UserPayments />} />
            <Route path="/user-profile" element={<UserProfile />} />
            <Route path="/user-sidebar" element={<UserSidebar />} />
            <Route path="/chi-siamo" element={<ChiSiamo />} />
            <Route path="/contatti" element={<Supporto />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/checkout" element={<PaymentStepper />} />
            <Route path="/checkout-payment-method" element={<PaymentForm />} />
          </Routes>
        </main>
        <FooterWrapper /> {/* Questo gestisce il Footer dinamicamente */}
      </div>
    </Router>
  );
};

export default App;
